import React from "react";
import { TextField, useMediaQuery, useTheme } from "@mui/material";

const SearchInput = ({
  filterText,
  setFilterText,
  placeholder = "Search...",
  sx = {},
  fullWidthOnMobile = true,
  ...rest
}) => {
  const theme = useTheme();

  // Responsive breakpoints
  const isXs = useMediaQuery(theme.breakpoints.down("sm")); // <600px
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–900px
  const isMdUp = useMediaQuery(theme.breakpoints.up("md")); // ≥900px

  // Dynamically decide width
  let computedWidth = "100%";
  if (isXs) computedWidth = "100%";
  else if (isSm) computedWidth = "60%";
  else if (isMdUp) computedWidth = "30%";

  return (
    <TextField
      label={placeholder}
      variant="outlined"
      value={filterText}
      onChange={(e) => setFilterText(e.target.value)}
      fullWidth={isXs && fullWidthOnMobile}
      sx={{
        width: computedWidth,
        minWidth: 200,
        maxWidth: 500,
        "& .MuiInputBase-root": {
          alignItems: "center",
        },
        "& .MuiInputLabel-root": {
          top: "50%",
          left: 10,
          transform: "translateY(-50%)",
          fontSize: "14px",
          color: "gray",
        },
        "& .MuiInputLabel-shrink": {
          top: 0,
          transform: "translateY(0)",
        },
        ...sx, // allow custom overrides
      }}
      {...rest}
    />
  );
};

export default SearchInput;
